export function setIPSearchesLoading (state, loading = false) {
  state.searchipsLoading = loading
}

export function setCkeysLoading (state, loading = false) {
  state.ckeysLoading = loading
}

export function setIPOrdersLoading (state, loading = false) {
  state.ipOrdersLoading = loading
}

export function setIPSearches (state, searches) {
  state.searchips = searches.data
  state.searchipsCurrentPage = searches.current_page
  state.searchipsLastPage = searches.last_page
  state.searchipsPerPage = searches.per_page
  state.searchipsTotal = searches.total
}

export function setCkeysOrders (state, { ip, ckeys }) {
  const index = state.searchips.findIndex(el => el._id.ip == ip)

  if(index > -1) {
    state.searchips[index].ckeys = state.searchips[index].ckeys.map(el => {
      const ckindex = ckeys.map(e => e._id.clientKEY).indexOf(el.name)
      return ckindex > -1 ? { ...el, comenzi: ckeys[ckindex].comenzi } : { ...el, comenzi: 0 }
    })
  }
}

export function setIPOrders (state, { ip }) {
  state.searchips.some((el, index) => {
    if(el._id.ip == ip) {
      state.searchips[index].comenzi_lm = (ip[0] && ip[0]['comenzi']) ? ip[0]['comenzi'] : 0
      return true
    }

    return false
  })
}

export function setIPsOrders2 (state, ips) {
  for (var key in ips) {
    const sindex = state.searchips.map(obj => obj._id.ip).indexOf(ips[key]._id)
    if (sindex !== -1) {
      state.searchips[sindex].comenzi_lm = ips[key].comenzi
    }
  }
}

export function setIPsOrders (state, ips) {
  for (var key in state.searchips) {
    const ipindex = ips.map(obj => obj._id).indexOf(state.searchips[key]._id.ip)
    state.searchips[key].comenzi_lm = (ipindex > -1) ? ips[ipindex].comenzi : 0
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setDatefrom (state, datefrom = '') {
  state.datefrom = datefrom
}

export function setDateto (state, dateto = '') {
  state.dateto = dateto
}
